/* eslint-disable jsdoc/require-param */
/* eslint-disable jsdoc/no-undefined-types */
/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect, useMemo, useCallback } from "react";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import {
  TextField,
  IconButton,
  LinearProgress,
  Card,
  makeStyles,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  Grid,
  Typography,
  TablePagination,
  Button,
} from "@material-ui/core";
import {
  DataGrid,
  GridOverlay,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { useCompany } from "../../../contexts/CompanyContext";

const useStyles = makeStyles(theme => ({
  grid: {
    border: 0,
  },
  root: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textField: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  overlay: {
    flexDirection: "column",
    "& .ant-empty-img-1": {
      fill: theme.palette.type === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.type === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.type === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.type === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.type === "light" ? "0.8" : "0.08",
      fill: theme.palette.type === "light" ? "#f5f5f5" : "#fff",
    },
  },
  label: {
    marginTop: theme.spacing(1),
  },
  filterContainer: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  paginationContainer: {
    padding: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  performanceInfo: {
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
  },
}));

/**
 * A custom DataGrid NoRowsOverlay component that displays a more
 * visually appealing message when no rows are available.
 *
 * @returns {React.Element} The NoRowsOverlay component.
 */
function CustomNoRowsOverlay() {
  const classes = useStyles();
  return (
    <GridOverlay className={classes.overlay}>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <div className={classes.label}>No Rows</div>
    </GridOverlay>
  );
}

/**
 * Enhanced QuickSearchToolbar with lifecycle status filtering and server-side pagination
 */
function EnhancedSearchToolbar(props) {
  const classes = useStyles();
  const [localSearchValue, setLocalSearchValue] = useState(props.value || "");
  const [localStatusFilter, setLocalStatusFilter] = useState(
    props.statusFilter || 0
  );

  const toolbarButtonStyle = {
    fontSize: ".875rem",
    padding: ".5rem .65rem",
    textTransform: "none",
  };

  // Handle search button click
  const handleSearchClick = useCallback(() => {
    props.onSearch(localSearchValue.trim(), localStatusFilter);
  }, [localSearchValue, localStatusFilter, props.onSearch]);

  // Handle Enter key press in search input
  const handleKeyPress = useCallback(
    event => {
      if (event.key === "Enter") {
        handleSearchClick();
      }
    },
    [handleSearchClick]
  );

  // Handle search input change (no API call)
  const handleSearchChange = useCallback(event => {
    setLocalSearchValue(event.target.value);
  }, []);

  // Handle status filter change (immediate API call)
  const handleStatusChange = useCallback(
    event => {
      const newStatus = event.target.value;
      setLocalStatusFilter(newStatus);
      props.onSearch(localSearchValue.trim(), newStatus);
    },
    [localSearchValue, props.onSearch]
  );

  // Clear search and execute
  const clearSearch = useCallback(() => {
    setLocalSearchValue("");
    setLocalStatusFilter(0);
    props.clearSearch();
    props.onSearch("", 0);
  }, [props.clearSearch, props.onSearch]);

  // Sync local values with props when they change externally
  useEffect(() => {
    setLocalSearchValue(props.value || "");
  }, [props.value]);

  useEffect(() => {
    setLocalStatusFilter(props.statusFilter || 0);
  }, [props.statusFilter]);

  // Memoize lifecycle status options for performance
  const statusOptions = useMemo(() => {
    const options = [{ id: 0, status_name: "All Statuses" }];

    if (props.lifecycleStatuses && props.lifecycleStatuses.length > 0) {
      options.push(
        ...props.lifecycleStatuses.map(status => ({
          id: status.id,
          status_name:
            status.status_name.charAt(0).toUpperCase() +
            status.status_name.slice(1),
        }))
      );
    } else {
      // Fallback status options if context data isn't available
      options.push(
        { id: 1, status_name: "Created" },
        { id: 2, status_name: "Active" },
        { id: 3, status_name: "Inactive" },
        { id: 4, status_name: "Deleted" },
        { id: 5, status_name: "Declined" }
      );
    }
    return options;
  }, [props.lifecycleStatuses]);

  return (
    <div>
      <Box className={classes.filterContainer}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={8} md={6}>
            <Box display="flex" gap={1} alignItems="center">
              <TextField
                variant="standard"
                value={localSearchValue}
                onChange={handleSearchChange}
                onKeyPress={handleKeyPress}
                placeholder="Search by name, email, phone, or Z-ID..."
                className={classes.textField}
                fullWidth
                InputProps={{
                  startAdornment: <SearchIcon fontSize="small" />,
                  endAdornment: localSearchValue && (
                    <IconButton
                      title="Clear"
                      aria-label="Clear"
                      size="small"
                      onClick={() => {
                        setLocalSearchValue("");
                        props.onSearch("", localStatusFilter);
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleSearchClick}
                disabled={props.loading}
                style={{ minWidth: "80px", height: "36px" }}
              >
                Search
              </Button>
            </Box>
            <Typography variant="caption" color="textSecondary">
              Tip: Search phone numbers using +27 or 27 instead of 0 (e.g. +27821234567)
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel>Lifecycle Status</InputLabel>
              <Select
                value={localStatusFilter}
                onChange={handleStatusChange}
                label="Lifecycle Status"
              >
                {statusOptions.map(status => (
                  <MenuItem key={status.id} value={status.id}>
                    {status.status_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
              {props.filteredCount !== props.totalCount && (
                <Chip
                  label={`Filtered: ${props.filteredCount}`}
                  color="primary"
                  size="small"
                  style={{ marginRight: "8px" }}
                />
              )}
              {(props.value || props.statusFilter > 0) && (
                <Button
                  size="small"
                  onClick={clearSearch}
                  color="secondary"
                  variant="outlined"
                  style={{
                    fontSize: "0.75rem",
                    padding: "2px 8px",
                    marginRight: "8px",
                  }}
                >
                  Clear All
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>

      <div className={classes.root}>
        <div /> {/* Spacer */}
        <GridToolbarContainer>
          <GridToolbarColumnsButton style={toolbarButtonStyle} />
          <GridToolbarFilterButton style={toolbarButtonStyle} />
          <GridToolbarDensitySelector style={toolbarButtonStyle} />
          <GridToolbarExport style={toolbarButtonStyle} />
        </GridToolbarContainer>
      </div>
    </div>
  );
}

/**
 * Custom pagination component for server-side pagination
 */
function CustomPagination({ pagination, onPageChange, className }) {
  const classes = useStyles();

  const handleChangePage = (event, newPage) => {
    // newPage is 0-based, but our API expects 1-based
    onPageChange(newPage + 1, pagination.limit);
  };

  const handleChangeRowsPerPage = event => {
    const newLimit = parseInt(event.target.value, 10);
    // Reset to page 1 when changing page size
    onPageChange(1, newLimit);
  };

  return (
    <Box className={`${classes.paginationContainer} ${className}`}>
      <Box>
        <Typography variant="caption" className={classes.performanceInfo}>
          Showing {pagination.startRecord}-{pagination.endRecord} of{" "}
          {pagination.filteredCount} results | Total dealers:{" "}
          {pagination.totalCount}
        </Typography>
      </Box>
      <TablePagination
        component="div"
        count={pagination.filteredCount}
        page={pagination.page - 1} // Convert to 0-based for component
        onPageChange={handleChangePage}
        rowsPerPage={pagination.limit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 100]}
        labelRowsPerPage="Records per page:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`}
      />
    </Box>
  );
}

const DealersDataGrid = ({
  rowsData,
  columns,
  loading,
  handleSelect,
  pagination,
  onPageChange,
  onSearch,
  queryInfo,
}) => {
  const { lifecycleStatuses } = useCompany();

  // Handle search execution
  const handleSearchAndFilter = useCallback(
    (searchValue, statusValue) => {
      onSearch(searchValue, statusValue);
    },
    [onSearch]
  );

  // Handle status filter changes (for the local state)
  const handleStatusChange = useCallback(() => {
    // This is handled internally by the toolbar now
  }, []);

  const clearSearch = useCallback(() => {
    // This is handled by the toolbar component
  }, []);

  return (
    <Card
      style={{ height: 700, width: "100%", overflow: "visible", padding: 20 }}
    >
      <LinearProgress
        style={{ opacity: loading ? 1 : 0, transition: "opacity .2s" }}
      />
      <div style={{ height: 600 }}>
        <DataGrid
          style={{ border: 0 }}
          components={{
            Toolbar: EnhancedSearchToolbar,
            NoRowsOverlay: CustomNoRowsOverlay,
          }}
          rows={rowsData}
          columns={columns}
          componentsProps={{
            toolbar: {
              value: queryInfo.search || "",
              statusFilter: queryInfo.statusFilter || 0,
              onSearch: handleSearchAndFilter,
              onStatusChange: handleStatusChange,
              clearSearch,
              totalCount: pagination.totalCount || 0,
              filteredCount: pagination.filteredCount || 0,
              lifecycleStatuses,
              loading,
            },
          }}
          loading={loading}
          checkboxSelection
          disableSelectionOnClick
          onSelectionModelChange={handleSelect}
          // Disable built-in pagination since we're using server-side
          pagination={false}
          hideFooterPagination
          hideFooter
        />
      </div>

      {/* Custom pagination component - Make sure it's visible */}
      <CustomPagination
        pagination={pagination}
        onPageChange={onPageChange}
        queryInfo={queryInfo}
        style={{ borderTop: "1px solid #e0e0e0", marginTop: "8px" }}
      />
    </Card>
  );
};

DealersDataGrid.defaultProps = {
  loading: false,
  handleUpdate: () => {},
  updateRunning: false,
  pagination: {
    page: 1,
    limit: 50,
    totalCount: 0,
    filteredCount: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    startRecord: 0,
    endRecord: 0,
  },
  onPageChange: () => {},
  onSearch: () => {},
  queryInfo: {
    search: "",
    statusFilter: 0,
    executionTime: null,
  },
};

export default DealersDataGrid;
